import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TransportadorPageEdit } from '@/features/transportador/page/edit/TransportadorPageEdit';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.literal('editar'),
        idpk: StringToIdpkSchema,
    }),
]);

export const Route = createFileRoute('/a/transportador/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <TransportadorPageEdit key={`${params.action}-${params.idpk}`} {...params} />;
}
